import ToastContext from './ToastContext'

const ToastConsumer = ToastContext.Consumer

export default ToastConsumer
